__webpack_require__.p = "/SolutionHotel/";